module.exports = __webpack_public_path__ + "img/cellphone-follow.c7c465de.png";